import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { FHIRService, ProfileManager, readFileAsText } from '@kailona/core';

function replacePatientIds(fhirResource, fhirPatientId) {
  if (fhirResource.resourceType === 'Observation') {
    fhirResource.subject = {
      reference: "Patient/".concat(fhirPatientId)
    };
  } // TODO: Add patient id replacement for other resources


  if (fhirResource.resourceType === 'Bundle' && fhirResource.entry) {
    fhirResource.entry.forEach(function (entry) {
      if (entry && entry.resource) {
        replacePatientIds(entry.resource, fhirPatientId);
      }
    });
  }
}

export function importJSON(_x) {
  return _importJSON.apply(this, arguments);
}

function _importJSON() {
  _importJSON = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
    var fileAsText, fhirResource, _ref, resourceType, type, fhirPatientId, bundleResource, fhirService;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return readFileAsText(file);

          case 2:
            fileAsText = _context.sent;
            fhirResource = JSON.parse(fileAsText);
            _ref = fhirResource || {}, resourceType = _ref.resourceType, type = _ref.type;

            if (resourceType) {
              _context.next = 8;
              break;
            }

            console.error('Invalid FHIR data');
            return _context.abrupt("return", false);

          case 8:
            fhirPatientId = ProfileManager.activePatientId;

            if (fhirPatientId) {
              _context.next = 12;
              break;
            }

            console.error('Invalid FHIR Patient Id');
            return _context.abrupt("return", false);

          case 12:
            _context.prev = 12;
            replacePatientIds(fhirResource, fhirPatientId);

            if (resourceType === 'Bundle' && (type === 'transaction' || type === 'batch')) {
              bundleResource = fhirResource;
            } else {
              bundleResource = {
                resourceType: 'Bundle',
                type: 'transaction',
                entry: [{
                  resource: fhirResource,
                  request: {
                    method: 'POST',
                    url: resourceType
                  }
                }]
              };
            }

            fhirService = new FHIRService();
            _context.next = 18;
            return fhirService.transaction(bundleResource);

          case 18:
            return _context.abrupt("return", true);

          case 21:
            _context.prev = 21;
            _context.t0 = _context["catch"](12);
            console.error('Failed to import data', _context.t0);

          case 24:
            return _context.abrupt("return", false);

          case 25:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[12, 21]]);
  }));
  return _importJSON.apply(this, arguments);
}

;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(replacePatientIds, "replacePatientIds", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/lib/importFHIRData.js");
  reactHotLoader.register(importJSON, "importJSON", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/lib/importFHIRData.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();